import { render, staticRenderFns } from "./QSummitStepChallengeBackground.vue?vue&type=template&id=2c201536&scoped=true&"
import script from "./QSummitStepChallengeBackground.vue?vue&type=script&lang=js&"
export * from "./QSummitStepChallengeBackground.vue?vue&type=script&lang=js&"
import style0 from "./QSummitStepChallengeBackground.vue?vue&type=style&index=0&id=2c201536&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c201536",
  null
  
)

export default component.exports